import React from "react";
import "../CSS/Industries.css";
import { Link } from "react-router-dom";

function Industries() {
  const industries = [
    {
      number: "01",
      title: "Retail & E-commerce",
      image: "/images/home/retail.png",
      description:
        "Technology solutions that help retailers manage customers, products, sales, inventory, and online business operations.",
      points: [
        "Inventory Management",
        "Sales & Billing Systems",
        "E-commerce Solutions",
        "Customer Management",
      ],
    },
    {
      number: "02",
      title: "Manufacturing",
      image: "/images/home/manufacturing.png",
      description:
        "Digital solutions designed to help manufacturing businesses manage operations, production, inventory, and business data.",
      points: [
        "Production Management",
        "Inventory Management",
        "Business Applications",
        "Reporting & Analytics",
      ],
    },
    {
      number: "03",
      title: "Healthcare",
      image: "/images/home/healthcare.png",
      description:
        "Software and digital solutions that help healthcare businesses organize information, manage operations, and improve workflows.",
      points: [
        "Appointment Management",
        "Patient Information",
        "Business Management",
        "Reporting Systems",
      ],
    },
    {
      number: "04",
      title: "Education",
      image: "/images/home/education.png",
      description:
        "Technology solutions for schools, institutes, training centers, and education businesses to simplify their daily operations.",
      points: [
        "Student Management",
        "Course Management",
        "Online Platforms",
        "Administration Systems",
      ],
    },
    {
      number: "05",
      title: "Real Estate",
      image: "/images/home/real-estate.png",
      description:
        "Digital solutions that help real estate businesses manage properties, customers, leads, and daily business activities.",
      points: [
        "Property Management",
        "Lead Management",
        "Customer Management",
        "Website & Web Applications",
      ],
    },
    {
      number: "06",
      title: "Finance & Accounting",
      image: "/images/home/finance.png",
      description:
        "Business software that helps organizations manage financial information, invoices, transactions, and accounting workflows.",
      points: [
        "Invoice Management",
        "Financial Records",
        "Reporting",
        "Business Automation",
      ],
    },
    {
      number: "07",
      title: "Logistics & Transportation",
      image: "/images/home/logistics.png",
      description:
        "Technology solutions that help logistics and transportation companies manage operations, customers, deliveries, and information.",
      points: [
        "Delivery Management",
        "Order Tracking",
        "Customer Management",
        "Business Reporting",
      ],
    },
    {
      number: "08",
      title: "Professional Services",
      image: "/images/home/professional.png",
      description:
        "Digital solutions for consulting firms, agencies, service providers, and other professional businesses.",
      points: [
        "Client Management",
        "Project Management",
        "Invoice Management",
        "Business Websites",
      ],
    },
    {
      number: "09",
      title: "Hospitality",
      image: "/images/home/hospitality.png",
      description:
        "Technology solutions that help hospitality businesses manage customers, services, bookings, and day-to-day operations.",
      points: [
        "Booking Management",
        "Customer Management",
        "Business Websites",
        "Reporting",
      ],
    },
    {
      number: "10",
      title: "Startups & Small Businesses",
      image: "/images/home/startups.png",
      description:
        "Affordable and scalable technology solutions that help startups and small businesses establish and grow their digital presence.",
      points: [
        "Business Websites",
        "Custom Software",
        "Mobile Applications",
        "Digital Marketing",
      ],
    },
  ];

  return (
    <>

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="industries-hero">
        <div className="container">
          <div className="industries-hero-content">
            <h1>Technology Solutions <br />
              <span>
                For Different Industries
              </span>
            </h1>
            <p>
              We create practical software, websites, applications, and
              digital solutions designed around the unique requirements of
              different industries.
            </p>
            <div className="about-hero-buttons">
              <Link to="/contactus" className="about-primary-button" >
                Let's Work Together
              </Link>
              <Link to="/services" className="about-secondary-button" >
                Explore Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          INTRODUCTION
      ===================================================== */}

      <section className="industries-intro">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <div className="industries-intro-content">
                <h2>
                  Technology Designed Around Your Industry
                </h2>
                <p>
                  Every industry has different processes, customers,
                  challenges, and business requirements. We believe technology
                  should support those differences rather than force every
                  business into the same solution.
                </p>
                <p>
                  Our team develops websites, web applications, software,
                  mobile applications, databases, and digital solutions that
                  can be adapted to the way your business operates.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
              <img
                src="/images/industries/industry-solutions.png"
                alt="Industry Technology Solutions"
                className="industries-intro-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          INDUSTRIES
      ===================================================== */}

      <section className="industries-list-section">
        <div className="container">
          <div className="section-heading text-center">
            <h2>
              Solutions For Your Business Sector
            </h2>
          </div>
          <div className="row g-4">
            {industries.map((industry) => (
              <div
                className="col-lg-6"
                key={industry.number}
              >
                <div className="industry-detail-card">

                  <div className="industry-image-wrapper">
                    <img
                      src={industry.image}
                      alt={industry.title}
                      className="industry-detail-image"
                    />

                  </div>

                  <div className="industry-detail-content">
                    <h3>{industry.title}</h3>
                    <p>
                      {industry.description}
                    </p>
                    <div className="industry-points">
                      {industry.points.map((point) => (
                        <div
                          className="industry-point"
                          key={point}
                        >
                          <span>✓</span>
                          <p>{point}</p>
                        </div>
                      ))}
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =====================================================
          TECHNOLOGY SECTION
      ===================================================== */}

      <section className="industries-technology">
        <div className="container">
          <div className="section-heading text-center">
            <h2>
              Technology Built for Your Industry
            </h2>
          </div>
          <div className="technology-grid">
            <div className="technology-card">
              <h3>Frontend</h3>
              <p>
                React, Angular, JavaScript, HTML, CSS and modern frontend
                technologies.
              </p>
            </div>

            <div className="technology-card">
              <h3>Backend</h3>
              <p>
                .NET, C#, PHP and other backend technologies based on project
                requirements.
              </p>
            </div>

            <div className="technology-card">
              <h3>Database</h3>
              <p>
                SQL databases, MongoDB and other data solutions for business
                applications.
              </p>
            </div>

            <div className="technology-card">
              <h3>Digital</h3>
              <p>
                Websites, SEO, social media, mobile applications and other
                digital solutions.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* =====================================================
          CTA
      ===================================================== */}

      <section className="industries-cta">
        <div className="container">

          <div className="industries-cta-box">

            <div className="cta-content">
              <span>LET'S WORK TOGETHER</span>

              <h2>
                Have An Industry-Specific Requirement?
              </h2>

              <p>
                Tell us about your business and requirements. We can discuss
                the right technology solution for your organization.
              </p>
            </div>

            <a
              href="/contactus"
              className="industries-cta-button" style={{ textDecoration: 'none' }}
            >
              Get In Touch
            </a>

          </div>

        </div>
      </section>
    </>
  );
}

export default Industries;